import React from 'react';

// items: [{ label, value, sub?, tone?: 'default' | 'good' | 'warn' | 'bad' }]
const TONE = { default: 'text-slate-900', good: 'text-emerald-600', warn: 'text-amber-600', bad: 'text-red-600' };

const StatGrid = ({ items }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
    {items.map((s) => (
      <div key={s.label} className="bg-white rounded-2xl border border-slate-200 p-3 md:p-5">
        <div className="text-xs font-medium text-slate-500 truncate">{s.label}</div>
        <div className={`mt-1 text-lg md:text-2xl font-semibold tabular-nums truncate ${TONE[s.tone || 'default']}`}>{s.value}</div>
        {s.sub && <div className="text-[11px] text-slate-400 mt-0.5 truncate">{s.sub}</div>}
      </div>
    ))}
  </div>
);

export default StatGrid;
